const form = document.querySelector("#id_filter_post_form");
if (form) {
  const category = form.querySelector("#id_category");
  category.addEventListener("change", function() {
    form.submit();
  });
}
